import Swiper from "swiper"
import { find } from "utils/dom"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	console.log('Page home');
	var swiper = new Swiper(".mySwiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".seta-esquerda",
        prevEl: ".seta-direita",
      },
      on: {
        slideChange: function () {
          const videosActive = document.querySelectorAll('.swiper-slide video')
          videosActive.forEach(v =>{
              v.muted = true
              v.pause()
          })
            
          videosActive[this.activeIndex].muted = false
          videosActive[this.activeIndex].play()
          console.log(videosActive[this.activeIndex]);
          
          //console.log('Slide ativo (índice):', this.activeIndex);
          //console.log('Slide ativo (elemento):', this.slides[this.activeIndex]);
        }
      }
    });

document.addEventListener('DOMContentLoaded', function () {
    const placeholder2 = document.getElementById('videoPlaceholder2');
    const background2 = document.getElementById('videoBackground2');
    const iframe2 = document.getElementById('vimeoPlayer2');
    const player2 = new Vimeo.Player(iframe2);

    function togglePlayPause2() {
      player2.getPaused().then(function (paused) {
        if (paused) {
          player2.play();
        } else {
          player2.pause();
        }
      });
    }

    placeholder2.addEventListener('click', togglePlayPause2);
    background2.addEventListener('click', togglePlayPause2);

    player2.on('play', function () {
      placeholder2.classList.add('hidden');
      background2.classList.add('hidden');
    });

    player2.on('pause', function () {
      placeholder2.classList.remove('hidden');
      background2.classList.remove('hidden');
    });
  });


   document.addEventListener('DOMContentLoaded', function () {
    const placeholder3 = document.getElementById('videoPlaceholder3');
    const background3 = document.getElementById('videoBackground3');
    const iframe3 = document.getElementById('vimeoPlayer3');
    const player3 = new Vimeo.Player(iframe3);

    function togglePlayPause3() {
      player3.getPaused().then(function (paused) {
        if (paused) {
          player3.play();
        } else {
          player3.pause();
        }
      });
    }

    placeholder3.addEventListener('click', togglePlayPause3);
    background3.addEventListener('click', togglePlayPause3);

    player3.on('play', function () {
      placeholder3.classList.add('hidden');
      background3.classList.add('hidden');
    });

    player3.on('pause', function () {
      placeholder3.classList.remove('hidden');
      background3.classList.remove('hidden');
    });
  });


  //   document.addEventListener('DOMContentLoaded', function () {
  //   const placeholder4 = document.getElementById('videoPlaceholder4');
  //   const background4 = document.getElementById('videoBackground4');
  //   const iframe4 = document.getElementById('vimeoPlayer4');
  //   const player4 = new Vimeo.Player(iframe4);

  //   function togglePlayPause4() {
  //     player4.getPaused().then(function (paused) {
  //       if (paused) {
  //         player4.play();
  //       } else {
  //         player4.pause();
  //       }
  //     });
  //   }

  //   placeholder4.addEventListener('click', togglePlayPause4);
  //   background4.addEventListener('click', togglePlayPause4);

  //   player4.on('play', function () {
  //     placeholder4.classList.add('hidden');
  //     background4.classList.add('hidden');
  //   });

  //   player4.on('pause', function () {
  //     placeholder4.classList.remove('hidden');
  //     background4.classList.remove('hidden');
  //   });
  // });
}